export function SET_SEQUENCE_REPORT(state, report) {
  state.sequenceReport = report;
}